import React, { useMemo, useState } from 'react';
import { Drawer } from 'antd';
import { Button } from 'antd-mobile';
import { useShowTime } from 'common-package';
import { Toast } from '@/components';
import CloseIcon from '@/assets/icon/DrawerClose.svg';
import { Timer } from '@/components/header';
import { storagePrefixV2 } from '@/constant';
import cx from './index.module.scss';

interface Props {
  screenPic?: string;
  points: Palpation.PointTypeWithDirection[];
  delWarningPointCb: () => Promise<string>;
  confirmKeepCb: VoidFunc;
  open: boolean;
  confirmLoading: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isSocketConnected: boolean;
}

const AnomalyDepthDrawer: React.FC<Props> = ({
  screenPic,
  points,
  delWarningPointCb,
  confirmKeepCb,
  open,
  setOpen,
  confirmLoading,
  isSocketConnected,
}) => {
  const [weekText, minuteText] = useShowTime('星期dd&HH:mm')?.split('&') || [];
  const leftPoints = useMemo(() => points.filter(item => item.isLeft && !!item.depthWarning), [points]);
  const rightPoints = useMemo(() => points.filter(item => !item.isLeft && !!item.depthWarning), [points]);
  const [isDeleting, setIsDeleting] = useState(false);

  return (
    <Drawer
      placement="right"
      width={'520px'}
      className={cx('depth-drawer')}
      styles={{
        header: { border: 'none' },
        body: { background: ' linear-gradient(180deg, #BBC2D0 0%, #E6E8EB 100%)' },
      }}
      closable={false}
      destroyOnClose={true}
      open={open}
    >
      <div className={cx('header')}>
        <Timer weekText={weekText} minuteText={minuteText} />
        <div className={cx('drawer-close')}>
          <img src={CloseIcon} alt="drawer-close" onClick={() => setOpen(false)} />
        </div>
      </div>
      <div className={cx('tips')}>
        <img src={storagePrefixV2 + '/lzja2bmk_589660.png'} />
        <div className={cx('text')}>
          人体检测中
          <span className={cx('highlight')}>痛点标记异常</span>
        </div>
      </div>
      <div className={cx('content')}>
        <div className={cx('img-wrapper')}>
          <div className={cx('img-box')} style={{ backgroundImage: `url(${screenPic})` }} />
        </div>
        <div>机器人检测到痛点的高度异常，可能存在安全风险，</div>
        {leftPoints.length > 0 && (
          <div className={cx('text-wrapper')}>
            <div> 左侧：</div>
            <div className={cx('pain-text')}>{leftPoints.map(item => `痛点${item?.index}`)?.join('、')}</div>
          </div>
        )}
        {rightPoints.length > 0 && (
          <div className={cx('text-wrapper')}>
            <div>右侧：</div>
            <div className={cx('pain-text')}>{rightPoints.map(item => `痛点${item?.index}`)?.join('、')}</div>
          </div>
        )}
        <div>请理疗师仔细确认痛点在人体上且远离人体边界</div>
      </div>
      <div className={cx('footer')}>
        <Button
          disabled={!isSocketConnected}
          loading={isDeleting}
          onClick={async () => {
            try {
              setIsDeleting(true);
              await delWarningPointCb();
            } catch {
              Toast.fail('网络错误');
            } finally {
              setIsDeleting(false);
            }
          }}
          className={cx('del-btn')}
        >
          删除
        </Button>
        <Button
          disabled={!isSocketConnected}
          loading={confirmLoading}
          className={cx('confirm-btn')}
          onClick={() => confirmKeepCb()}
        >
          确认保留
        </Button>
      </div>
    </Drawer>
  );
};

export default AnomalyDepthDrawer;
